import { render } from "./designInputPreview.vue?vue&type=template&id=22cd2610"
import script from "./designInputPreview.vue?vue&type=script&lang=js"
export * from "./designInputPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__